import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

function IconButton({ iconName = '', className = '', onClick = () => {} }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`tv-icon_button ${className}`}
      aria-label="Icon Button"
    >
      <i className={`fa fa-${iconName}`} />
    </button>
  );
}

IconButton.propTypes = {
  iconName: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default IconButton;
